import Link from 'next/link';

import styled from '@emotion/styled';

import { TileHyperLinkIcon } from '@web/ui/icons';

import { HubClasses, HubTile } from '../HubTile';

// The gif lives beside the route that has always used it; `?url` keeps it out
// of the sharp-loader responsive pipeline, which cannot handle an animation.
import room from '../../../app/(public)/the-room/room.gif?url';

const SHubTile = styled(HubTile)`
  position: relative;
  overflow: hidden;
  background: #0a0a0a;
  color: ${({ theme }) => theme.color.light};

  .${HubClasses.topRowContainer} {
    align-items: flex-start;
  }

  /* Full-width across three columns by design; stacked on a phone it shrinks to
     text height and the room art is cropped to a strip behind the copy. */
  ${({ theme }) => theme.breakpoints.down('sm')} {
    min-height: 20rem;
  }
`;

const Background = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  z-index: 0;
`;

const Scrim = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0) 32%,
    rgba(0, 0, 0, 0.25) 50%,
    rgba(0, 0, 0, 0.72) 72%,
    rgba(0, 0, 0, 0.9) 100%
  );
`;

const Spacer = styled.div`
  flex: 1 1 auto;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('0750')};
`;

const Subtitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.color.light};
  font: ${({ theme }) => theme.typography.body.bold};
  font-size: ${({ theme }) => theme.typescale.size['4']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.condensed};
`;

const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.color.light};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['1']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
  opacity: ${({ theme }) => theme.opacity.dense};
`;

const CTA = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing('0500')};
  margin-top: ${({ theme }) => theme.spacing('1000')};
  color: ${({ theme }) => theme.color.light};
  font: ${({ theme }) => theme.typography.mono.regular};
  font-size: ${({ theme }) => theme.typescale.size['0875']};
  line-height: ${({ theme }) => theme.typescale.lineHeight.extended};
`;

export const TheRoomTile = () => (
  <Link href="/the-room">
    <SHubTile
      textColor="light"
      stateLayer="light"
      title="The Room"
      badge={<TileHyperLinkIcon size="0750" />}
    >
      <Background src={room} alt="" />
      <Scrim />
      <Spacer />
      <Content>
        <Subtitle>The Room</Subtitle>
        <Description>
          An early corner of the Valley, kept as it was.
        </Description>
        <CTA>
          Step inside
          <TileHyperLinkIcon size="0750" />
        </CTA>
      </Content>
    </SHubTile>
  </Link>
);
